import { Link as RouterLink } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Stack } from "@mui/material";
// components
import Page from "../components/Page";
//
import { MaintenanceIllustration } from "../assets";
import Image from "src/components/Image";
import TextMaxLine from "src/components/TextMaxLine";
import { m } from "framer-motion";
import { varFade } from "src/components/animate";

// ----------------------------------------------------------------------

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 520,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function MaintenancePlanned({ sx }) {
  return (
    <Page title="Maintenance">
      <Container>
        <ContentStyle sx={{ textAlign: "center", alignItems: "center" }}>
          <m.div {...varFade().inDown}>
            <Stack sx={{ mb: 3 }}>
              <Image
                sx={{
                  maxWidth: sx?.width || 120,
                  maxHeight: sx?.height || 120,
                  objectFit: "contain",
                }}
                src={window.globalTS?.logo}
              />
            </Stack>
          </m.div>

          <m.div {...varFade().inUp}>
            <Image src="/assets/maintenance.png" sx={{ width: "100%" }} />
            <Stack sx={{ my: 2 }}>
              <Typography variant="h4" paragraph>
                Schedule maintenance is in-progress!
              </Typography>

              <TextMaxLine variant="subtitle1" sx={{ color: "text.secondary" }}>
                We should be done in <strong>2 hours and 15 minutes</strong>
              </TextMaxLine>
            </Stack>
          </m.div>
        </ContentStyle>
      </Container>
    </Page>
  );
}
